export default {
  filtersApplied: (countAppliedFilters) =>
    `Filters Applied: (${countAppliedFilters})`,
  clearAll: 'Clear All',
  yourSelections: 'Your Selections',
}
